import React, { useState, useEffect, useRef } from "react";
import dropdownicon from "../../Assets/Images/AssignUserToRole/dropdownicon.png";
import { API_BASE_URL } from "../../Config/Config";

const SchoolSearch = ({ onSchoolSelect }) => {
  const [inputValue, setInputValue] = useState("");
  const [schools, setSchools] = useState([]);
  const [selectedSchoolName, setSelectedSchoolName] = useState("");
  const dropdownRef = useRef(null);

  const onChangeHandler = async (e) => {
    const searchKey = e.target.value;
    setInputValue(searchKey); // Update the input field value

    if (searchKey.trim() === "") {
      setSchools([]); // Clear the dropdown when input is empty
    } else {
      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-schools-list/?search_key=${searchKey}`
        );

        if (response.ok) {
          const data = await response.json();
          setSchools(data); // Update the list of schools
        } else {
          console.error("Failed to fetch schools:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching schools:", error);
      }
    }
  };

  const onSelectSchool = (school) => {
    setSelectedSchoolName(school.school_name); // Set the selected school's name
    setInputValue(school.school_name); // Update the input field with the selected school's name
    onSchoolSelect(school); // Call the callback with the selected school
    setSchools([]); // Clear the dropdown after selection
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setSchools([]); // Close the dropdown if clicked outside
    }
  };

  useEffect(() => {
    // Add the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Remove the event listener using the correct method
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div style={{ position: "relative" }} ref={dropdownRef}>
      <label style={{ fontSize: "14px" }}>School Name</label>
      <div
        className="aur-search-dropbtn"
        style={{ width: "100%", backgroundColor: "white" }}
      >
        <input
          type="text"
          placeholder="Type here to Search..."
          style={{ padding: "10px", width: "91%", height: "30px" }}
          value={inputValue} // Display the current input value
          onChange={onChangeHandler} // Handle input changes
          onClick={() => setSelectedSchoolName("")} // Allow input modification after selecting
        />
        <button
          // onClick={()=>{onSearch("")}}
          style={{
            backgroundColor: "white",
            border: "none",
            height: "25px",
            marginTop: "4px",
          }}
        >
          <img src={dropdownicon} alt="" />
        </button>
      </div>

      {schools.length > 0 && (
        <div
          style={{
            position: "absolute", // Keep the dropdown from affecting layout
            top: "100%", // Position right below the input
            width: "100%",
            border: "1px solid #ccc",
            borderRadius: "4px",
            maxHeight: "150px",
            overflowY: "auto",
            backgroundColor: "white",
            zIndex: 1, // Ensure it appears on top
          }}
        >
          {schools.map((school) => (
            <div
              key={school.school_id}
              style={{
                padding: "10px",
                cursor: "pointer",
                backgroundColor: "white",
                borderBottom: "1px solid #eee",
              }}
              onClick={() => onSelectSchool(school)}
            >
              {school.school_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SchoolSearch;
